// Test IDs
export const TID = {
  // nav
  navLogo: "nav-logo",
  navLogin: "nav-login",
  navRegister: "nav-register",
  navLogout: "nav-logout",
  navDashboard: "nav-dashboard",
  navDiscover: "nav-discover",

  // landing
  heroCta: "hero-cta",
  heroSecondary: "hero-secondary",

  // auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  registerName: "register-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerRoleSeller: "register-role-seller",
  registerRoleBuyer: "register-role-buyer",
  registerCompany: "register-company",
  registerInterests: "register-interests",
  registerSubmit: "register-submit",
  registerError: "register-error",

  // discovery
  discoverSearch: "discover-search",
  discoverCategoryAll: "discover-category-all",
  discoverGrid: "discover-grid",
  recoRow: "reco-row",
  recoReason: "reco-reason",

  // product card
  productCard: "product-card",
  productCardTitle: "product-card-title",
  productCardPrice: "product-card-price",
  productCardTimer: "product-card-timer",

  // product detail
  productDetail: "product-detail",
  productBuy: "product-buy",
  productDelete: "product-delete",

  // seller
  sellerCreateBtn: "seller-create-btn",
  sellerStats: "seller-stats",
  sellerProducts: "seller-products",
  productTitle: "product-title-input",
  productDesc: "product-desc-input",
  productPrice: "product-price-input",
  productStock: "product-stock-input",
  productCategory: "product-category-input",
  productTags: "product-tags-input",
  productImage: "product-image-input",
  productAiEnhance: "product-ai-enhance",
  productSubmit: "product-submit",

  // admin
  adminStats: "admin-stats",
};

export default TID;
